exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".aspect-ratio{padding-top:50%;position:relative;width:100%}.centered-video{bottom:0;left:0;position:absolute;right:0;text-align:center;top:0}.centered-video-table{display:flex;flex-direction:column;justify-content:center}.full-video-dims{border:10px solid #000;border-radius:2vw;margin:10px auto}.video-btn-flex{display:flex;justify-content:space-between}.video-show{display:inline-flex}.video-head{color:red;width:100px}.video-show-margin{margin:20px auto}.video-show-table-margin{margin:10px 0}.video-text{color:red;font-size:.9rem;margin-bottom:0}.video-url-text{color:red;font-size:.9rem}.video-url-text:hover{color:#b00;text-decoration:underline}@media(min-width: 992px){.full-video-dims{height:36vw;width:48vw}}@media(min-width: 900px)and (max-width: 992px){.full-video-dims{height:30vw;width:40vw}}@media(min-width: 768px)and (max-width: 900px){.full-video-dims{height:36vw;width:48vw}}@media(max-width: 767px){.centered-video-table{top:30vmin}.full-video-dims{height:60vmin;width:80vmin}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/videos/components/Video/Video.scss
// module id = 360
// module chunks = 0